import { createFileRoute, redirect } from '@tanstack/react-router'

import { Center, Tag } from '@masterplandev/ui'

import Loader from '@/core/components/ui/Loader/Loader'
import { useCourseDetails } from '@/course-generic/queries/useCourseDetails'
import { TopicPage } from '@/topic/components/TopicPage/TopicPage'
import { TopicPageContent } from '@/topic/components/TopicPageContent/TopicPageContent'

export const Route = createFileRoute(
  '/_learning/course-generic/$course/$topic/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { course, topic } = Route.useParams()
  const { data, isPending } = useCourseDetails({ slug: course })

  if (isPending) {
    return (
      <Center position="fixed" inset="0">
        <Loader />
      </Center>
    )
  }

  if (!isPending && !data) {
    throw redirect({ to: '/home' })
  }

  return (
    <TopicPage>
      <TopicPageContent
        context="course-generic"
        extraInfo={
          <Tag variant="outline" mb="4" size="lg">
            {data.title}
          </Tag>
        }
        courseSlug={course}
        topicSlug={topic}
      />
    </TopicPage>
  )
}
